<template>
 <router-view :key="$route.fullPath"/>
</template>

<script>
export default {
  name:"Event"
}
</script>

<style scoped>

</style>
